// extracted by mini-css-extract-plugin
module.exports = {"icoLoading":"LoadingApp_icoLoading__uNTGh","loadingCircle":"LoadingApp_loadingCircle___EuAN"};